import { useFeatureConfig } from '../contexts/FeatureConfigContext';

// Tháng được quyền cập nhật doanh số — BE trả `thangMo` cho tính năng `sales` (admin Tính năng app → 5. Doanh số nhập).
// Chưa có `thangMo` (BE cũ) → coi như mở, để không khoá nhầm cả hệ thống lúc giao thời.
export const useThangDoanhSo = (month, year) => {
  const { features } = useFeatureConfig();
  const sales = features.find((f) => f.featureKey === 'sales');
  const duocMo = !sales?.thangMo || (sales.thangMo[String(year)] || []).includes(Number(month));
  return { duocMo, thongBao: sales?.notificationText || '' };
};

// Thông báo đỏ khi tháng đang chọn chưa mở — nội dung anh Bình tự ghi trên admin (notification_text)
export const ThongBaoKhoaThang = ({ month, year, thongBao }) => (
  <div className="mx-4 mb-3 px-4 py-3 rounded-lg text-sm bg-red-50 border border-red-300 text-red-800">
    <div className="font-semibold">🔒 Tháng {Number(month) || month}/{year} chưa mở cập nhật doanh số</div>
    {thongBao && <p className="text-xs mt-1 whitespace-pre-line">{thongBao}</p>}
  </div>
);
